export const SEMESTER_LIST_REQUEST = 'SEMESTER_LIST_REQUEST';
export const SEMESTER_LIST_SUCCESS = 'SEMESTER_LIST_SUCCESS';
export const SEMESTER_LIST_FAIL = 'SEMESTER_LIST_FAIL';
export const SEMESTER_LIST_RESET = 'SEMESTER_LIST_RESET';
export const SEMESTER_LIST_REMOVE_ITEM = 'SEMESTER_LIST_REMOVE_ITEM';

export const SEMESTER_DETAILS_REQUEST = 'SEMESTER_DETAILS_REQUEST';
export const SEMESTER_DETAILS_SUCCESS = 'SEMESTER_DETAILS_SUCCESS';
export const SEMESTER_DETAILS_FAIL = 'SEMESTER_DETAILS_FAIL';
export const SEMESTER_DETAILS_RESET = 'SEMESTER_DETAILS_RESET';

export const SEMESTER_EDIT_REQUEST = 'SEMESTER_EDIT_REQUEST';
export const SEMESTER_EDIT_SUCCESS = 'SEMESTER_EDIT_SUCCESS';
export const SEMESTER_EDIT_FAIL = 'SEMESTER_EDIT_FAIL';
export const SEMESTER_EDIT_RESET = 'SEMESTER_EDIT_RESET';

export const SEMESTER_ADD_REQUEST = 'SEMESTER_ADD_REQUEST';
export const SEMESTER_ADD_SUCCESS = 'SEMESTER_ADD_SUCCESS';
export const SEMESTER_ADD_FAIL = 'SEMESTER_ADD_FAIL';
export const SEMESTER_ADD_RESET = 'SEMESTER_ADD_RESET';

export const SEMESTER_DELETE_REQUEST = 'SEMESTER_DELETE_REQUEST';
export const SEMESTER_DELETE_SUCCESS = 'SEMESTER_DELETE_SUCCESS';
export const SEMESTER_DELETE_FAIL = 'SEMESTER_DELETE_FAIL';
export const SEMESTER_DELETE_RESET = 'SEMESTER_DELETE_RESET';
